document.querySelectorAll('.project-gallery__filters').forEach((filterList) => {
  const grid = filterList.closest('.page-width')?.querySelector('.project-gallery__grid');
  if (!grid) return;

  filterList.addEventListener('click', (event) => {
    const button = event.target.closest('.project-gallery__filter');
    if (!button) return;

    filterList.querySelectorAll('.project-gallery__filter').forEach((btn) => {
      const isActive = btn === button;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive.toString());
    });

    const filter = button.dataset.filter;
    grid.querySelectorAll('.project-gallery__item').forEach((item) => {
      const matches = filter === 'all' || item.dataset.tag === filter;
      item.hidden = !matches;
    });
  });
});
